export const formatNumber = (value: number) => value.toLocaleString('sv-SE')
